export function stampForCreate() {
    const { userId } = JSON.parse(localStorage.getItem('AuthReducer'));

    return {
        by: userId,
        ts: new Date(),
    };
}

export function stampForUpdate() {
    const { userId } = JSON.parse(localStorage.getItem('AuthReducer'));

    return {
        updatedBy: userId,
        updatedTs: new Date(),
    };
}

export function getLoggedInUserId() {
    const { userId } = JSON.parse(localStorage.getItem('AuthReducer'));
    return userId;
}

export function includeStamp(data) {
    if (data._id) {
        Object.assign(data, stampForUpdate());
    }
    else {
        Object.assign(data, stampForCreate());
    }
    return data;
}

export default {
    stampForCreate,
    stampForUpdate,
    getLoggedInUserId,
    includeStamp,
};
